module.exports = __webpack_public_path__ + "static/media/teachersaid-teacher-template.a3ac114e.xlsx";